import React from "react";
import LinkListPage from "@/components/institute/LinkListPage";

export default function InstituteNotices() {
  return (
    <LinkListPage
      eyebrow="Communications"
      title="Notices & Circulars"
      subtitle="General notices and circulars published by the institute. Each entry has a name (max 100 characters), an active/inactive status, and either an attached PDF (max 5 MB) or an external link."
      listUrl="/institute/notices?type=general"
      mutateBaseUrl="/institute/notices"
      extraPayload={{ notice_type: "general" }}
      testidPrefix="inst-notices"
      itemNoun="Notice"
      uploadKind="inst_notice_pdf"
    />
  );
}
